import React, { FC } from 'react';
import styled from 'styled-components';
import Colours from '../../../design-system/colours';

const OvHormonePatternLegend: FC = () => (
  <LegendWrapper>
    <LegendItem>
      <LegendDot color={Colours.OV_DARK_GREEN} /> LH
    </LegendItem>
    <LegendItem>
      <LegendDot color={Colours.POST_OVULATION} /> PdG
    </LegendItem>
    <LegendItem>
      <LegendDot color={Colours.LIME_GREEN} /> E3G
    </LegendItem>
  </LegendWrapper>
);

export default OvHormonePatternLegend;

const LegendWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  color: ${Colours.OV_BASE};
  font-size: 0.875rem;
  margin-bottom: 0.125rem;
`;

const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.375rem;
`;

const LegendDot = styled.span<{ color: string }>`
  width: 0.625rem;
  height: 0.625rem;
  border-radius: 50%;
  background: ${(p) => p.color};
  display: inline-block;
`;
